<template>
  <section class="position-relative">
    <div class="bg-element text-element">
      &lt;{{ bgTitle }}/&gt;
    </div>
    <div class="container">
      <h2 class="h1 font-gradient text-center mb-4 mb-lg-5">{{ title }}</h2>
      <div class="row justify-content-center">
        <div class="col-lg-8 text-center">
          <p>{{ text }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'AboutComponent',
  data () {
    return {
      title: 'About Me',
      text: 'Hello! I’m Martin, a Web Developer with over 11 years of experience specializing in both Front-End and Back-End development. I’m passionate about refining my existing skills while continuously exploring and mastering new areas in programming and coding. Let’s build something amazing together!',
      bgTitle: 'About'
    }
  }
}
</script>
